import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { BillingClient, FileResponse, PortalRequest } from "../web-api-client.ts";

async function fileResponseToJson<T>(fr: FileResponse): Promise<T> {
  const text = await fr.data.text();
  return JSON.parse(text) as T;
}

type Props = {
  dealerId?: number;              // optional; server can infer from auth
  variant?: string;               // bootstrap variant
  size?: "sm" | "lg";
  text?: string;
  className?: string;
};

const ManageBillingButton: React.FC<Props> = ({ dealerId, variant = "outline-secondary", size, text = "Manage Billing", className }) => {
  const [working, setWorking] = useState(false);
  const billingClient = useMemo(() => new BillingClient(), []);

  async function openPortal() {
    setWorking(true);
    try {
      const dto: PortalRequest = { dealerId: dealerId as any }; // optional – inferred server-side
      const fr = await billingClient.billing_CreatePortal(dto);
      const { sessionUrl } = await fileResponseToJson<{ sessionUrl: string }>(fr);
      window.location.href = sessionUrl;
    } finally {
      setWorking(false);
    }
  }

  return (
    <Button variant={variant} size={size} onClick={openPortal} disabled={working} className={className}>
      {working ? "Opening…" : text}
    </Button>
  );
};

export default ManageBillingButton;
